import React from 'react';
import ReactTable from 'react-table';
import { mustBeArray } from '../../utils/lib';
import _ from 'lodash-es';
import { Input } from 'reactstrap';

const CompanyFilesList = props => {
    const {handleCheckboxSelection,selectedCompany, list} = props;
    const getRCTIListColumns =  () => {
        return([
        {
            id: 'selected',
            accessor: x => x.selected,
            Header: <div className="flex justify-content-center pl-1 selectableRowCheckbox">
                    <Input type="checkbox"
                        checked={false}
                        disabled={true}
                    />
                </div>,
            maxWidth: 60,
            sortable: false,
            Cell: row => (<div className="flex justify-content-center pl-1 selectableRowCheckbox">
                        <Input type="checkbox"
                                onChange={()=> handleCheckboxSelection(row.original)}
                                checked={row.original.id === selectedCompany}
                            />
                </div>)
        },
        {
            id: 'name',
            Header: 'Company File',
            accessor: x => x.name
        }
    ]);
  };
    return(
        <ReactTable
            sortable
            filterable={false}
            showPagination={false}
            data={mustBeArray(list)}
            columns={getRCTIListColumns()}
            minRows={mustBeArray(list).length === 0 ? 5 : mustBeArray(list).length}
            className="selectableRowTable br-1"
        />
    );
};
export default CompanyFilesList;